import { render } from "./App.vue?vue&type=template&id=73201772"
const script = {}

import "./App.vue?vue&type=style&index=0&id=73201772&lang=css"

import exportComponent from "/tmp/build_3e230bee/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__